export const GET_SERVICE_CHARGES = 'providers/settings/ServiceCharges/GET_SERVICE_CHARGES';
export const GET_SERVICE_CHARGES_BY_PAGINATION = 'providers/settings/ServiceCharges/GET_SERVICE_CHARGES_BY_PAGINATION';
export const CREATE_SERVICE_CHARGE = 'providers/settings/ServiceCharges/CREATE_SERVICE_CHARGE';
export const GET_SERVICE_CHARGE = 'providers/settings/ServiceCharges/GET_SERVICE_CHARGE';
export const UPDATE_SERVICE_CHARGE = 'providers/settings/ServiceCharges/UPDATE_SERVICE_CHARGE';
export const DELETE_SERVICE_CHARGE = 'providers/settings/ServiceCharges/DELETE_SERVICE_CHARGE';
export const SET_IS_ENABLED_SERVICE_CHARGE = 'providers/settings/ServiceCharges/SET_IS_ENABLED_SERVICE_CHARGE';
